/**
 * "Would a reload cost the user something right now?" (BUG-056)
 *
 * Nothing applies an update on its own any more, but a tap while a 9 MB video
 * is on the wire would restart that upload from zero, and an unsent capture
 * sitting in the editor lives in memory until it's sent or discarded. Both
 * queues already broadcast their pending counts and the camera state is a
 * zustand store — this is the union of the three, plus a change signal so a
 * deferred update fires the moment the work drains.
 */
import { sendEngine } from '../services/queue/engine';
import { useCameraStore } from '../store/cameraStore';

let sending = 0;
let saving = 0;

const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((cb) => cb());
}

// One queue since FEAT-028 wave 4, but sends and saves are still counted
// apart. `pending` already includes in-flight direct attempts.
sendEngine.onState((state) => {
  sending = state.pending;
  saving = state.saving;
  notify();
});
useCameraStore.subscribe(notify);

/** True while a send/save is on the wire or an unsent capture is being held. */
export function isBusy(): boolean {
  const { currentCapture, captureQueue } = useCameraStore.getState();
  return sending > 0 || saving > 0 || !!currentCapture || captureQueue.length > 0;
}

/** Fires whenever that answer might have changed. Returns an unsubscribe. */
export function onBusyChange(callback: () => void): () => void {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
